"use client";

import { useEffect } from "react";
import { isLocalDevHost } from "@/lib/isLocalDevHost";

export default function GTMOnInteraction() {
  useEffect(() => {
    // Keep local dev sessions out of the production analytics / Clarity projects
    if (isLocalDevHost()) return;

    const loadGTM = () => {
      if (window.gtmScriptLoaded) return;
      window.gtmScriptLoaded = true;
      const script = document.createElement("script");
      script.id = "gtm-script";
      // crossOrigin: gtm.js sends CORS headers, so errors from it reach Clarity
      // with a real message instead of the masked "Script error."
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.crossOrigin='anonymous';j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-5TQQ8MS');`;
      document.head.appendChild(script);
    };

    // Load GTM during browser idle time instead of on the first interaction.
    // The old "first click/scroll/keydown" trigger fired the whole GTM tag
    // cascade (GA + Clarity + Facebook) *on* a user interaction, blocking the
    // main thread exactly when the user acted -> mobile INP > 200ms (Search
    // Console: /ea, /caira, /contact-us et al). requestIdleCallback keeps GTM
    // off the critical load path (LCP/TBT unaffected) AND off the interaction
    // path, and it loads for non-interacting sessions too (better analytics
    // coverage than the old interaction gate). Timeout fallback where rIC missing.
    let idleId: number | undefined;
    let timerId: ReturnType<typeof setTimeout> | undefined;
    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(loadGTM, { timeout: 3500 });
    } else {
      timerId = setTimeout(loadGTM, 3000);
    }

    return () => {
      if (idleId !== undefined) window.cancelIdleCallback?.(idleId);
      if (timerId) clearTimeout(timerId);
    };
  }, []);

  return null;
}
